export const availableStatusOptions = [
  {
    label: "Inválido",
    value: "invalid",
  },
  {
    label: "Válido",
    value: "valid",
  },
  {
    label: "Pendiente",
    value: "pending_upload",
  },
  {
    label: "En revisión",
    value: "pending_review",
  },
];
